
export const WakeLock = () => {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
  }
  enableWakeLock();
}

export const toggleFullscreen = () => {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
  } else {
    document.exitFullscreen();
  }
}

export const enableWakeLock = async (reAcquire = true) => {
  if ('WakeLock' in window && 'request' in window.WakeLock) {
    console.log("WakeLock using WakeLock API");
    let wakeLock = null;

    const requestWakeLock = () => {
      const controller = new AbortController();
      const signal = controller.signal;
      window.WakeLock.request('screen', {signal})
      .catch((e) => {
        if (e.name === 'AbortError') {
          console.log('Wake Lock was aborted');
        } else {
          console.error(`${e.name}, ${e.message}`);
        }
      });
      console.log('Wake Lock is active');
      return controller;
    };

    const handleVisibilityChange = () => {
      if (wakeLock !== null && document.visibilityState === 'visible') {
        wakeLock = requestWakeLock();
      }
    };

    if (reAcquire) {
      document.addEventListener('visibilitychange', handleVisibilityChange);
      document.addEventListener('fullscreenchange', handleVisibilityChange);
    } else {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      document.removeEventListener('fullscreenchange', handleVisibilityChange);
    }
  }  else if ('wakeLock' in navigator && 'request' in navigator.wakeLock) {
    console.log("WakeLock using wakeLock API");
    let wakeLock = null;

    const requestWakeLock = async () => {
      try {
        wakeLock = await navigator.wakeLock.request('screen');
        wakeLock.addEventListener('release', () => {
          console.log('Wake Lock was released');
        });
        console.log('Wake Lock is active');
      } catch (e) {
        console.error(`${e.name}, ${e.message}`);
      }
    };

    const handleVisibilityChange = () => {
      if (wakeLock !== null && document.visibilityState === 'visible') {
        requestWakeLock();
      }
    };

    if (reAcquire) {
      document.addEventListener('visibilitychange', handleVisibilityChange);
      document.addEventListener('fullscreenchange', handleVisibilityChange);
    } else {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      document.removeEventListener('fullscreenchange', handleVisibilityChange);
    }
    await requestWakeLock();
  } else {
    console.warn("Wake lock not supported in browser, check: https://web.dev/wakelock/")
  }
}

export default WakeLock;